export const LANGS = [
  { code: "it", country: "it", label: "IT" },
  { code: "en", country: "gb", label: "EN" },
  { code: "fr", country: "fr", label: "FR" },
  { code: "es", country: "es", label: "ES" },
  { code: "de", country: "de", label: "DE" },
];

export const Flag = ({ country, className = "h-3.5 w-5 rounded-[2px] object-cover" }) => (
  <img src={`/menu-assets/flags/${country}.png`} alt={country} className={className} loading="lazy" />
);

export const STR = {
  it: {
    discover: "Scopri il menu", explore: "Esplora il menu", philosophy: "La nostra filosofia",
    home: "Home", menu: "Menu", search: "Cerca", allergens: "Allergeni",
    searchPh: "Cerca un piatto o una categoria…", noResults: "Nessun piatto trovato. Prova con un altro termine.",
    unavailable: "Non disponibile", allergenInfo: "Informazioni sugli allergeni",
    privacy: "Privacy", contacts: "Contatti", reserved: "Area riservata",
    scroll: "Scorri", dishes: "piatti", backToMenu: "Torna al menu",
    allergensTitle: "Informazioni sugli allergeni",
    allergensSub: "Ai sensi del Reg. UE 1169/2011, ecco l'elenco dei 14 allergeni. Il nostro staff è a disposizione per ogni informazione su ingredienti e preparazioni.",
    searchResults: "Risultati per", translating: "Traduzione del menu in corso…",
  },
  en: {
    discover: "Discover the menu", explore: "Explore the menu", philosophy: "Our philosophy",
    home: "Home", menu: "Menu", search: "Search", allergens: "Allergens",
    searchPh: "Search a dish or category…", noResults: "No dishes found. Try another term.",
    unavailable: "Unavailable", allergenInfo: "Allergen information",
    privacy: "Privacy", contacts: "Contacts", reserved: "Staff area",
    scroll: "Scroll", dishes: "dishes", backToMenu: "Back to menu",
    allergensTitle: "Allergen information",
    allergensSub: "Under EU Regulation 1169/2011, here is the list of the 14 allergens. Our staff is available for any information about ingredients and preparations.",
    searchResults: "Results for", translating: "Translating the menu…",
  },
  fr: {
    discover: "Découvrir le menu", explore: "Explorer le menu", philosophy: "Notre philosophie",
    home: "Accueil", menu: "Menu", search: "Rechercher", allergens: "Allergènes",
    searchPh: "Rechercher un plat ou une catégorie…", noResults: "Aucun plat trouvé. Essayez un autre terme.",
    unavailable: "Indisponible", allergenInfo: "Informations sur les allergènes",
    privacy: "Confidentialité", contacts: "Contacts", reserved: "Espace réservé",
    scroll: "Défiler", dishes: "plats", backToMenu: "Retour au menu",
    allergensTitle: "Informations sur les allergènes",
    allergensSub: "Conformément au règlement UE 1169/2011, voici la liste des 14 allergènes. Notre équipe reste à votre disposition pour toute information sur les ingrédients.",
    searchResults: "Résultats pour", translating: "Traduction du menu en cours…",
  },
  es: {
    discover: "Descubrir el menú", explore: "Explorar el menú", philosophy: "Nuestra filosofía",
    home: "Inicio", menu: "Menú", search: "Buscar", allergens: "Alérgenos",
    searchPh: "Buscar un plato o categoría…", noResults: "No se encontraron platos. Prueba con otro término.",
    unavailable: "No disponible", allergenInfo: "Información sobre alérgenos",
    privacy: "Privacidad", contacts: "Contactos", reserved: "Área reservada",
    scroll: "Desliza", dishes: "platos", backToMenu: "Volver al menú",
    allergensTitle: "Información sobre alérgenos",
    allergensSub: "Según el Reglamento UE 1169/2011, esta es la lista de los 14 alérgenos. Nuestro personal está a tu disposición para cualquier información sobre ingredientes.",
    searchResults: "Resultados para", translating: "Traduciendo el menú…",
  },
  de: {
    discover: "Menü entdecken", explore: "Menü entdecken", philosophy: "Unsere Philosophie",
    home: "Start", menu: "Menü", search: "Suchen", allergens: "Allergene",
    searchPh: "Gericht oder Kategorie suchen…", noResults: "Keine Gerichte gefunden. Versuchen Sie einen anderen Begriff.",
    unavailable: "Nicht verfügbar", allergenInfo: "Allergeninformationen",
    privacy: "Datenschutz", contacts: "Kontakt", reserved: "Reservierter Bereich",
    scroll: "Scrollen", dishes: "Gerichte", backToMenu: "Zurück zum Menü",
    allergensTitle: "Allergeninformationen",
    allergensSub: "Gemäß EU-Verordnung 1169/2011 finden Sie hier die Liste der 14 Allergene. Unser Team informiert Sie gerne über Zutaten und Zubereitungen.",
    searchResults: "Ergebnisse für", translating: "Menü wird übersetzt…",
  },
};

export const loc = (obj, lang) => (obj && (obj[lang] || obj.it)) || "";

export const sget = (s, base, lang) => (s && (s[`${base}_${lang}`] || s[`${base}_it`])) || "";

export const phil = (p, lang, suffix) => (p && (p[`${lang}_${suffix}`] || p[`it_${suffix}`])) || "";
